function SvgWater(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 56 82" {...props}>
      <path
        d="M55.5 50c-.8-4.7-2.6-9-4.4-12.9-5.4-11.9-11.9-22.7-18.3-32.7L32 3C30.9 1.3 29.6.4 28.1.4c-2.2 0-3.6 2-4 2.6v.1l-1.4 2.2c-2.5 4-5.1 8.2-7.6 12.4-3.9 6.6-8.8 15.4-12.4 24.8C1.5 45.6.4 48.7.3 52.1c-.4 8.8 2.8 16.2 9.4 22 5.1 4.5 11.6 7 18.3 7 9.8 0 18.7-5 23.8-13.5C55.2 62 56.5 56 55.5 50zm-6.9 15.7C44.2 73.1 36.5 77.4 28 77.4c-5.8 0-11.5-2.1-15.9-6-5.7-5-8.5-11.5-8.2-19.1.1-2.8 1-5.5 2.2-8.4 3.5-9.2 8.3-17.8 12.1-24.3 2.4-4.1 5-8.3 7.6-12.3l1.3-2.1c0-.1.1-.1.1-.2.2-.3.6-.8.8-.9 0 0 .3.1.8.9l.8 1.3c6.2 9.8 12.7 20.5 18 32.2 1.7 3.8 3.4 7.8 4.1 12 1 5.2-.1 10.3-3.1 15.2zm-18.8 2.2c0 1-.8 1.8-1.8 1.8-9.1 0-16.4-7.4-16.4-16.4 0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8C15.3 60.3 21 66 28 66c1 0 1.8.9 1.8 1.9z"
      />
    </svg>
  );
}

export default SvgWater;
